import {schema} from 'normalizr'

export const keywordSchema = new schema.Entity(
  'keywords',
  {},
  {
    idAttribute: 'idname'
  }
)
